import { render, staticRenderFns } from "./SurveySpecimenInfo.vue?vue&type=template&id=007572b6&scoped=true"
import script from "./SurveySpecimenInfo.vue?vue&type=script&lang=js"
export * from "./SurveySpecimenInfo.vue?vue&type=script&lang=js"
import style0 from "./SurveySpecimenInfo.vue?vue&type=style&index=0&id=007572b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007572b6",
  null
  
)

export default component.exports